// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#courseGroupList {
  margin-bottom: 5px;
  width: 100%;
  margin-top: 3px;
  overflow: hidden;
}

#courseGroupList .col-md-12 {
  background-color: #e5e5e5;
}

#courseGroupList .courseGroupInfo {
  background-color: #f2f2f2;
  padding-left: 2rem;
}
#courseGroupList h3 {
  margin: 0px 0px 15px;
}

#courseGroupList .mainImg {
  width: 100%;
}

#courseGroupList .assignment {
  border-bottom: 6px solid #ffffff;
  padding-top: 5px;
  padding-bottom: 2rem;
}

#courseGroupList .dueDate {
  padding-left: 4rem;
  display: block;
  padding-bottom: 1.5rem;
}

#courseGroupList .description.short {
  padding-right: 1rem;
}

#courseGroupList .mainImg {
  padding-left: 2rem;
}

#courseGroupList .info {
  padding-left: 2rem;
}

#courseGroupList .assignmentName {
  margin-top: 0px;
  margin-bottom: 0px;
  font-weight: bold;
  font-size: 16px;
}

.arrow {
  display: none;
  position: absolute;
  bottom: -3px;
  width: calc(100% - 10px);
}

.assignment.rightColumn .arrow,
.assignment.leftColumn .arrow {
  width: calc(100% - 5px);
}

.arrow .arrowTopBorder {
  height: 1.1rem;
  background-color: #e5e5e5;
}

.arrow .point {
  width: 100%;
  position: absolute;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  z-index: 10;
}

#courseGroupList .body {
  background-color: #f2f2f2;
  overflow: hidden;
  padding: 5px;
  padding-left: 10px;
}

.users .row .col-md-12 h4,
#courseGroupList .body h4 {
  margin: 0px;
}

#courseGroupList .body .info {
}

#courseGroupList .body .info .content {
  overflow: hidden;
  width: 300px;
  float: left;
  margin-right: 15px;
  position: relative;
}

#courseGroupList .body .info .content .mainImg {
  background-color: #bbb;
  float: left;
  margin-right: 15px;
  width: 300px;
}

#courseGroupList .closer {
  -webkit-border-radius: 15px;
  -moz-border-radius: 15px;
  border-radius: 15px;
  height: 30px;
  line-height: 27px;
  right: 15px;
  width: 30px;
}

#courseGroupList .body .info .infoHolder {
  float: left;
  width: 100%;
}

#courseGroupList .offeringSlide {
  background-color: #fff;
  display: none;
  max-height: 120px;
  overflow: scroll;
  position: absolute;
  right: 10px;
  width: 50%;
  z-index: 100;
}

#courseGroupList .body .info .infoHolder .apiActionLoader {
  margin-bottom: 7px;
  overflow: hidden;
}

/* code, type and source on slide down */
.slideDownMeta {
  padding-left: 0px;
  padding-top: 4rem;
  color: black;
  font-size: 16px;
  list-style: none;
}

.dateBlock {
  display: block;
}

.slideDownMeta li {
  display: inline-block;
}

.slideDownMeta li.space {
  margin: 0px 15px;
}

.singlecourse .offerings {
  width: 100%;
}

/***** assignment list & catalog list pages *****/
/* Need some specific styling for these pages */
#assignmentCourseList #singlecourse {
  margin-left: calc(8.3% * 3);
  width: calc(100% - 8.3% * 3);
  padding: 0;
  margin-top: 0;
}
/* Hide the meta information on the single course slide down on these pages only */
#assignmentCourseList #singlecourse .slideDownMeta {
  display: none;
}
#assignmentCourseList #singlecourse .body {
  background-color: white;
}
#assignmentCourseList #singlecourse .body .description {
  padding-bottom: 1rem;
}

.ScheduleCourseModal .title {
  font-weight: bold;
}

.ScheduleCourseModal .modal .requestContainer {
  width: 100%;
}

.ScheduleCourseModal .dateContainer {
  position: relative;
  overflow: hidden;
  display: flex;
}

.ScheduleCourseModal .actionHolder {
  margin-top: 1rem;
  overflow: visible;
  width: 100%;
}

.ScheduleCourseModal .RequestApprovalbtn {
  padding: 1rem 3rem !important;
}

.ScheduleCourseModal .Schedulebtn {
  padding: 1rem 6rem !important;
}

/* The course meta id/type/etc */
#courseGroupList .courseMeta {
  display: flex;
  justify-content: flex-begin;
  flex-direction: row;
  font-size: 14px;
  padding-top: 0.1rem;
  flex-wrap: wrap;
}
/* Pipe bars between course meta items*/
#courseGroupList .courseMeta span:nth-last-child(n + 2):after {
  content: '|';
  color: black;
  padding-right: 6px;
  margin-left: 1.5rem;
  margin-right: 0.9rem;
}

/* The course meta id/type/etc */
#courseGroupList .courseMetaManager {
  display: flex;
  justify-content: flex-begin;
  flex-direction: row;
  font-size: 14px;
  padding-top: 0.1rem;
}
/* Pipe bars between course meta items*/
#courseGroupList .courseMetaSpan:nth-last-child(n + 2):after e {
  content: '|';
  color: black;
  padding-right: 6px;
  margin-left: 1.5rem;
  margin-right: 0.9rem;
}

#courseGroupList .singlecourse {
  margin-left: 0px !important;
  width: 100% !important;
  border-bottom: 6px solid #ffffff;
}

#courseGroupList .space {
  margin-top: 12px;
  margin-left: 10px;
  margin-right: 10px;
}

#courseGroupList .courseGroupInfoHolder {
  display: inline-flex;
}

#courseGroupList .resource {
  color: black;
  float: left;
  font-size: 14px;
  text-decoration: underline;
  margin-top: 10px;
}

#assignmentCourseList #singlecourse .title {
  padding-right: 10px;
}

#courseGroupList .point {
  top: 30px;
  border-top-color: #e5e5e5;
  border-right-color: transparent;
  border-left-color: transparent;
  border-top-width: 40px;
  border-right-width: 200px;
  border-left-width: 200px;
  border-top-style: solid;
  border-right-style: solid;
  border-left-style: solid;
}

#courseGroupList .arrow {
  position: absolute;
  bottom: 0px !important;
  width: 20% !important;
  background-color: #ffffff !important;
}

#assignmentCourseList #courseGroupList .arrowTopBorder {
  background-color: #ffffff !important;
  height: 1.1rem;
}

#assignmentCourseList #courseGroupList .assignment {
  border-top: 0px solid #ffffff !important;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/users/courseGroupSlideDown.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,wCAAwC;EACxC,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;AACb;;AAEA;AACA;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,wCAAwC;AACxC;EACE,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA,iDAAiD;AACjD,+CAA+C;AAC/C;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,UAAU;EACV,aAAa;AACf;AACA,kFAAkF;AAClF;EACE,aAAa;AACf;AACA;EACE,uBAAuB;AACzB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;AACA,uCAAuC;AACvC;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;AACA,uCAAuC;AACvC;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,+BAA+B;EAC/B,8BAA8B;EAC9B,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,wCAAwC;AAC1C","sourcesContent":["#courseGroupList {\n  margin-bottom: 5px;\n  width: 100%;\n  margin-top: 3px;\n  overflow: hidden;\n}\n\n#courseGroupList .col-md-12 {\n  background-color: #e5e5e5;\n}\n\n#courseGroupList .courseGroupInfo {\n  background-color: #f2f2f2;\n  padding-left: 2rem;\n}\n#courseGroupList h3 {\n  margin: 0px 0px 15px;\n}\n\n#courseGroupList .mainImg {\n  width: 100%;\n}\n\n#courseGroupList .assignment {\n  border-bottom: 6px solid #ffffff;\n  padding-top: 5px;\n  padding-bottom: 2rem;\n}\n\n#courseGroupList .dueDate {\n  padding-left: 4rem;\n  display: block;\n  padding-bottom: 1.5rem;\n}\n\n#courseGroupList .description.short {\n  padding-right: 1rem;\n}\n\n#courseGroupList .mainImg {\n  padding-left: 2rem;\n}\n\n#courseGroupList .info {\n  padding-left: 2rem;\n}\n\n#courseGroupList .assignmentName {\n  margin-top: 0px;\n  margin-bottom: 0px;\n  font-weight: bold;\n  font-size: 16px;\n}\n\n.arrow {\n  display: none;\n  position: absolute;\n  bottom: -3px;\n  width: calc(100% - 10px);\n}\n\n.assignment.rightColumn .arrow,\n.assignment.leftColumn .arrow {\n  width: calc(100% - 5px);\n}\n\n.arrow .arrowTopBorder {\n  height: 1.1rem;\n  background-color: #e5e5e5;\n}\n\n.arrow .point {\n  width: 100%;\n  position: absolute;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  z-index: 10;\n}\n\n#courseGroupList .body {\n  background-color: #f2f2f2;\n  overflow: hidden;\n  padding: 5px;\n  padding-left: 10px;\n}\n\n.users .row .col-md-12 h4,\n#courseGroupList .body h4 {\n  margin: 0px;\n}\n\n#courseGroupList .body .info {\n}\n\n#courseGroupList .body .info .content {\n  overflow: hidden;\n  width: 300px;\n  float: left;\n  margin-right: 15px;\n  position: relative;\n}\n\n#courseGroupList .body .info .content .mainImg {\n  background-color: #bbb;\n  float: left;\n  margin-right: 15px;\n  width: 300px;\n}\n\n#courseGroupList .closer {\n  -webkit-border-radius: 15px;\n  -moz-border-radius: 15px;\n  border-radius: 15px;\n  height: 30px;\n  line-height: 27px;\n  right: 15px;\n  width: 30px;\n}\n\n#courseGroupList .body .info .infoHolder {\n  float: left;\n  width: 100%;\n}\n\n#courseGroupList .offeringSlide {\n  background-color: #fff;\n  display: none;\n  max-height: 120px;\n  overflow: scroll;\n  position: absolute;\n  right: 10px;\n  width: 50%;\n  z-index: 100;\n}\n\n#courseGroupList .body .info .infoHolder .apiActionLoader {\n  margin-bottom: 7px;\n  overflow: hidden;\n}\n\n/* code, type and source on slide down */\n.slideDownMeta {\n  padding-left: 0px;\n  padding-top: 4rem;\n  color: black;\n  font-size: 16px;\n  list-style: none;\n}\n\n.dateBlock {\n  display: block;\n}\n\n.slideDownMeta li {\n  display: inline-block;\n}\n\n.slideDownMeta li.space {\n  margin: 0px 15px;\n}\n\n.singlecourse .offerings {\n  width: 100%;\n}\n\n/***** assignment list & catalog list pages *****/\n/* Need some specific styling for these pages */\n#assignmentCourseList #singlecourse {\n  margin-left: calc(8.3% * 3);\n  width: calc(100% - 8.3% * 3);\n  padding: 0;\n  margin-top: 0;\n}\n/* Hide the meta information on the single course slide down on these pages only */\n#assignmentCourseList #singlecourse .slideDownMeta {\n  display: none;\n}\n#assignmentCourseList #singlecourse .body {\n  background-color: white;\n}\n#assignmentCourseList #singlecourse .body .description {\n  padding-bottom: 1rem;\n}\n\n.ScheduleCourseModal .title {\n  font-weight: bold;\n}\n\n.ScheduleCourseModal .modal .requestContainer {\n  width: 100%;\n}\n\n.ScheduleCourseModal .dateContainer {\n  position: relative;\n  overflow: hidden;\n  display: flex;\n}\n\n.ScheduleCourseModal .actionHolder {\n  margin-top: 1rem;\n  overflow: visible;\n  width: 100%;\n}\n\n.ScheduleCourseModal .RequestApprovalbtn {\n  padding: 1rem 3rem !important;\n}\n\n.ScheduleCourseModal .Schedulebtn {\n  padding: 1rem 6rem !important;\n}\n\n/* The course meta id/type/etc */\n#courseGroupList .courseMeta {\n  display: flex;\n  justify-content: flex-begin;\n  flex-direction: row;\n  font-size: 14px;\n  padding-top: 0.1rem;\n  flex-wrap: wrap;\n}\n/* Pipe bars between course meta items*/\n#courseGroupList .courseMeta span:nth-last-child(n + 2):after {\n  content: '|';\n  color: black;\n  padding-right: 6px;\n  margin-left: 1.5rem;\n  margin-right: 0.9rem;\n}\n\n/* The course meta id/type/etc */\n#courseGroupList .courseMetaManager {\n  display: flex;\n  justify-content: flex-begin;\n  flex-direction: row;\n  font-size: 14px;\n  padding-top: 0.1rem;\n}\n/* Pipe bars between course meta items*/\n#courseGroupList .courseMetaSpan:nth-last-child(n + 2):after e {\n  content: '|';\n  color: black;\n  padding-right: 6px;\n  margin-left: 1.5rem;\n  margin-right: 0.9rem;\n}\n\n#courseGroupList .singlecourse {\n  margin-left: 0px !important;\n  width: 100% !important;\n  border-bottom: 6px solid #ffffff;\n}\n\n#courseGroupList .space {\n  margin-top: 12px;\n  margin-left: 10px;\n  margin-right: 10px;\n}\n\n#courseGroupList .courseGroupInfoHolder {\n  display: inline-flex;\n}\n\n#courseGroupList .resource {\n  color: black;\n  float: left;\n  font-size: 14px;\n  text-decoration: underline;\n  margin-top: 10px;\n}\n\n#assignmentCourseList #singlecourse .title {\n  padding-right: 10px;\n}\n\n#courseGroupList .point {\n  top: 30px;\n  border-top-color: #e5e5e5;\n  border-right-color: transparent;\n  border-left-color: transparent;\n  border-top-width: 40px;\n  border-right-width: 200px;\n  border-left-width: 200px;\n  border-top-style: solid;\n  border-right-style: solid;\n  border-left-style: solid;\n}\n\n#courseGroupList .arrow {\n  position: absolute;\n  bottom: 0px !important;\n  width: 20% !important;\n  background-color: #ffffff !important;\n}\n\n#assignmentCourseList #courseGroupList .arrowTopBorder {\n  background-color: #ffffff !important;\n  height: 1.1rem;\n}\n\n#assignmentCourseList #courseGroupList .assignment {\n  border-top: 0px solid #ffffff !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
